import { chakra } from "@chakra-ui/react";

export const Form = chakra("form", { baseStyle: { w: "full" } });
